import React from 'react';
import { useNavigate } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();

  return (
    <div style={styles.footer}>
      <p style={styles.company}>© 2026 TradePower Solutions Inc. DBA TradePower. All rights reserved.</p>
      <div style={styles.links}>
        <span style={styles.link} onClick={() => navigate('/terms')}>Terms of Service</span>
        <span style={styles.divider}>•</span>
        <span style={styles.link} onClick={() => navigate('/privacy')}>Privacy Policy</span>
        <span style={styles.divider}>•</span>
        <span style={styles.text}>Charlotte, NC</span>
      </div>
    </div>
  );
}

const styles = {
  footer: {
    backgroundColor: 'white', borderTop: '1px solid #eee',
    padding: '20px 32px', textAlign: 'center',
    marginTop: 'auto',
  },
  company: { fontSize: '12px', color: '#999', marginBottom: '6px' },
  links: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' },
  link: {
    fontSize: '12px', color: '#E94560', cursor: 'pointer',
    textDecoration: 'underline',
  },
  divider: { fontSize: '12px', color: '#ccc' },
  text: { fontSize: '12px', color: '#999' },
};

export default Footer;